import { Component, OnInit } from '@angular/core';
import { DispatchOrder } from '../dispatch-order/dispatch-order';
import { DispatchOrderService } from '../dispatch-order/dispatch-order-service';
import { Authenticate } from '../authenticate/authenticate';
import { User } from '../user/user';
import { UserService } from '../_services';

@Component({
  selector: 'app-dispatch-order-listview',
  templateUrl: './dispatch-order-listview.component.html',
  styleUrls: ['../machine/machine.component.less', '../app.component.less', './dispatch-order-listview.component.css']
})
export class DispatchOrderListviewComponent implements OnInit {
  
  //#region LOCAL VARIABLES
  _auth: Authenticate;
  _currentuser: User;
  _dispatchorders: DispatchOrder[];
  _userrole: string;
  isLoading = false;
  searchquery: string;
  searchqueryOid: string;
//#endregion

  constructor(private dispatchorderservice: DispatchOrderService,
    private userservice: UserService
  ) { }

  // PAGE LOAD
  ngOnInit(): void {
    this.isLoading = true;
    this._currentuser = this.userservice.getCurrentUserFromCookie();
    this._userrole = this._currentuser.role.name;
    // GET ALL DATASET
    if (this._userrole == "Authenticated" || this._userrole == "Administrator") {
      this.dispatchorderservice.getDispatchOrders().subscribe(resp => {
        this._dispatchorders = resp.reverse();
        this.isLoading = false;
      });
    }

    //GET CLIENT DATASET 
    if (this._userrole == "clientsrole") {
      this.dispatchorderservice.getDispatchOrdersCl(this._currentuser.client.id).subscribe(resp => {
        this._dispatchorders = resp.reverse();
        this.isLoading = false;
      }
      );
    }
  }

// SEARCH DISPATCHES BY DISPATCH ID
  searchOid(Oid: string) {
    try {
      if (this._userrole == "clientsrole") {
        this.dispatchorderservice.getDispatchOrderByCriteriaClient("id", Oid, this._currentuser.client.id).subscribe(resp => {
          this._dispatchorders = resp;
        });
      }
      else {
        this.dispatchorderservice.getDispatchOrderQL(Number(Oid)).subscribe(resp => {
          this._dispatchorders.splice(0, this._dispatchorders.length);
          this._dispatchorders.push(resp);
        });
      }
    }
    catch {
      window.alert("Results not found");
    }
  }

  // SEARCH DISPATCHES BY DEVICE SERIAL NUMBER
  search(serialnumber: string) {
    try {
      if (this._userrole == "clientsrole") {
        this.dispatchorderservice.getDispatchOrdersByMachineSerialNumberQl(serialnumber, this._currentuser.client.id).subscribe(resp => {
          this._dispatchorders = resp;



        });
      }
      else {
        this.dispatchorderservice.getDispatchOrdersByMachineSerialNumberQl(serialnumber).subscribe(resp => {
          this._dispatchorders = resp;
        });
      }

    }
    catch {
      window.alert("Results not found");
    }
  }


}
